import React from 'react';
import Polyline from 'react-google-maps/lib/Polyline';
import Marker from 'react-google-maps/lib/Marker';
import OverlayView from 'react-google-maps/lib/OverlayView';
import MyGoogleMap from './MyGoogleMap';

const getRoutePointIcon = () => ({
  path: window.google.maps.SymbolPath.CIRCLE,
  fillColor: 'blue',
  fillOpacity: 1,
  scale: 10,
  strokeColor: 'white',
  strokeWeight: 2
});

export default class RouteEdit extends React.PureComponent {

  state = {};

  componentDidMount() {
    this.geocoder = new window.google.maps.Geocoder();
    this.bounds = this.calculateBounds(this.props.route);
  }

  getDistance = (pos1, pos2) => {

    return Math.sqrt(
      Math.pow(Math.abs(+pos1.gps_lat - +pos2.gps_lat), 2) + Math.pow(Math.abs(+pos1.gps_long - +pos2.gps_long), 2)
    );
  };

  geocodePoint = (point) => {
    this.geocoder && this.geocoder.geocode({
      location: this.toLatLng(point)
    }, (response, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        // if we have a city information in one of the resposnes, use it directly
        const cityNameResponse = response.find(c => {
          return c.types.indexOf('locality') !== -1;
        });

        let name = point.name;
        if (cityNameResponse) {
          name = cityNameResponse.formatted_address;
        } else if (response.length > 0) {
          // find locality address component in any of the responses
          for (let i = 0; i < response.length; i++) {
            const cityComponent = response[i].address_components.find(c => {
              return c.types.indexOf('locality') !== -1
            });

            if (cityComponent) {
              name = cityComponent.long_name;
              break;
            }
          }
        }

        this.props.onChange && this.props.onChange({
          ...this.props.route,
          points: this.props.route.points.map(p => p === point ? { ...p, name } : p)
        });
      }
    });
  };

  handleMapClick = ({ latLng }) => {
    const point = this.addPointToRoute({ gps_lat: latLng.lat(), gps_long: latLng.lng() });

    this.geocodePoint(point);
  };

  createHandleUpdatePoint = (point) => ({ latLng }) => {
    const zoom = this.map && this.map.getZoom() || 8;
    var scale = Math.pow(2, zoom);
    const snapDistance = 20 / scale;

    const newPointLatLng = { gps_lat: latLng.lat(), gps_long: latLng.lng() };

    const closeLocation = this.props.locations.find(
      l => this.getDistance(l, newPointLatLng) < snapDistance
    );

    let newPoint;

    if (closeLocation) {
      newPoint = {
        ...point,
        location_id: closeLocation.id,
        location: closeLocation,
        gps_lat: closeLocation.gps_lat,
        gps_long: closeLocation.gps_long,
      }
    } else {
      newPoint = {
        ...point,
        ...newPointLatLng,
        location_id: null,
        location: null
      }
    }

    this.props.onChange && this.props.onChange({
      ...this.props.route,
      points: this.props.route.points.map(p => p === point ? newPoint : p)
    });

    setTimeout(() => this.geocodePoint(newPoint), 200);
  };

  createHandleDeletePoint = (point) => () => {
    this.props.onChange && this.props.onChange({
      ...this.props.route,
      points: this.props.route.points.filter(p => p !== point)
    });
  };

  createHandleLocationClick = (location) => () => {
    const point = {
      location_id: location.id,
      location: location,
      gps_lat: location.gps_lat,
      gps_long: location.gps_long,
    };

    this.addPointToRoute(point);
  };

  addPointToRoute = (point) => {
    this.props.onChange && this.props.onChange({
      ...this.props.route,
      points: [
        ...this.props.route.points,
        point
      ]
    });

    return point;
  };

  handleMapLoad = (map) => {
    this.map = map;

    if (map && this.bounds) {
        map.fitBounds(this.bounds);
    }
  };

  toLatLng = (p) => {
    return {
      lat: +p.gps_lat,
      lng: +p.gps_long
    }
  };

  calculateBounds = (route) => {
      if (route) {
          const points = route.points.slice();

          const bounds = new window.google.maps.LatLngBounds();
          points.map(p => bounds.extend({
              lat: parseFloat(p.gps_lat),
              lng: parseFloat(p.gps_long)
          }));

          return bounds;
      }
  };

  render() {
    const { locations, route, roundtrip } = this.props;

    return (
      <div>
        <MyGoogleMap
          onClick={this.handleMapClick}
          defaultZoom={8}
          onMapLoad={this.handleMapLoad}
        >
          {
            locations.map(
            (l, i) =>
              <Marker
                key={`location_${l.id}`}
                position={this.toLatLng(l)}
                // label={{
                //   text: l.name
                // }}
                onClick={this.createHandleLocationClick(l)}
              />
          )}
          {
            locations.map(
            (l, i) =>
              <OverlayView
                key={`location_label_${l.id}`}
                position={this.toLatLng(l)}
                mapPaneName={OverlayView.OVERLAY_LAYER}
                getPixelPositionOffset={(width, height) => ({
                  x: 0,
                  y: -height,
                })}
              >
                <div style={{ background: `white`, border: `0px solid #ccc`, padding: "2px 5px", opacity: 0.9 }}>
                  {l.name}
                </div>
              </OverlayView>
          )}
          {
            route.points.map(
            (p, i) =>
              <Marker
                key={`point_${i}`}
                position={this.toLatLng(p)}
                draggable
                label={{
                  text: `${i+1}`,
                  color: 'white'
                }}
                onDragEnd={this.createHandleUpdatePoint(p)}
                onRightClick={this.createHandleDeletePoint(p)}
                icon={getRoutePointIcon()}
              />
          )}
          {
            route.points.length > 1 &&
            <Polyline
              path={route.points.map(p => this.toLatLng(p))}
              options={{
                strokeColor: 'blue'
              }}
            />
          }
          {
            route.points.length > 1 && roundtrip && // close the path if it's A to A flight (roundtrip)
            <Polyline
              path={[
                this.toLatLng(route.points[route.points.length - 1]),
                this.toLatLng(route.points[0])
              ]}
              options={{
                strokeColor: 'blue'
              }}
            />
          }
        </MyGoogleMap>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/used/requests/RouteEdit.js